import { useInView } from '../../hooks/useInView';

const steps = [
  {
    number: '01',
    title: 'Take 2 Capsules Daily',
    desc: 'Simply take 2 capsules each morning with water, ideally with food. Consistent daily use is key to results.',
  },
  {
    number: '02',
    title: 'Build Natural Support',
    desc: 'During weeks 1–2, the botanical extracts begin to accumulate and support your body\'s natural processes.',
  },
  {
    number: '03',
    title: 'Experience Results',
    desc: 'By weeks 3–4, most men report noticeable improvements in volume, libido, and overall reproductive vitality.',
  },
];

export default function HowItWorksSection() {
  const [ref, inView] = useInView(0.1);

  return (
    <section
      data-testid="how-it-works-section"
      style={{ backgroundColor: '#FFFFFF', padding: '96px 0' }}
    >
      <div ref={ref} className="max-w-7xl mx-auto px-6 md:px-12">
        <div className={`text-center mb-14 fade-up ${inView ? 'visible' : ''}`}>
          <span className="overline block mb-4">Simple Process</span>
          <h2 style={{
            fontFamily: 'Outfit, sans-serif',
            fontWeight: 800,
            fontSize: 'clamp(1.8rem, 4vw, 2.8rem)',
            color: '#0D1A2E',
            letterSpacing: '-0.025em',
          }}>
            How RELOAD Works
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {steps.map((step, i) => (
            <div
              key={step.number}
              data-testid={`step-card-${i}`}
              className={`card-light rounded-2xl p-8 fade-up delay-${i + 1} ${inView ? 'visible' : ''}`}
              style={{ position: 'relative', overflow: 'hidden' }}
            >
              {/* Large ghost number */}
              <div style={{
                position: 'absolute',
                top: '-20px',
                right: '12px',
                fontFamily: 'Outfit, sans-serif',
                fontSize: '7rem',
                fontWeight: 900,
                color: 'rgba(27,61,126,0.05)',
                lineHeight: 1,
                userSelect: 'none',
                pointerEvents: 'none',
              }}>
                {step.number}
              </div>

              {/* Step badge */}
              <div style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '46px',
                height: '46px',
                borderRadius: '50%',
                border: '1.5px solid #1B3D7E',
                fontFamily: 'Outfit, sans-serif',
                fontSize: '1rem',
                fontWeight: 800,
                color: '#1B3D7E',
                marginBottom: '20px',
                position: 'relative',
                zIndex: 2,
              }}>
                {i + 1}
              </div>

              <h3 style={{
                fontFamily: 'Outfit, sans-serif',
                fontSize: '1.15rem',
                fontWeight: 700,
                color: '#0D1A2E',
                marginBottom: '12px',
                position: 'relative',
                zIndex: 2,
              }}>
                {step.title}
              </h3>
              <p style={{
                fontFamily: 'Manrope, sans-serif',
                fontSize: '0.87rem',
                color: '#64748B',
                lineHeight: 1.8,
                position: 'relative',
                zIndex: 2,
              }}>
                {step.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
